import * as React from 'react';
import { importantInfoContent } from '../../../content/content';
import { DataTest } from '../../../utilities/testAutomation';
import Tiles, { importantInfoOptionsTiles } from '../../Tiles/Tiles';

const Parser = require('html-react-parser');

interface ImportantInfoProps extends DataTest {
  planType: string;
}

const ImportantInfo = ({
  planType,
  dataTest,
}: ImportantInfoProps) => (
  <div className="important-info">
    <div className="container">
      <div className="important-info__border-box border-box">
        {Parser(importantInfoContent.lifeExpectancy)}
        {Parser(importantInfoContent.considerations)}
      </div>
      <div className="print-results hide-print">
        <Tiles single items={importantInfoOptionsTiles} planType={planType} />
        {/* <button onClick={() => window.print()} {...dataTest}><PrintIcon /> {importantInfoContent.printResults}</button> */}
      </div>
    </div>
  </div>
);

export default ImportantInfo;



// WEBPACK FOOTER //
// ./src/components/Outputs/ImportantInfo/ImportantInfo.tsx